import { ILLMConfig } from '@/models/llmConfig.model';
import { LLMConfigFormFields } from './types';

export const getLLMConfigInitialValues = (config?: ILLMConfig | null) => ({
  [LLMConfigFormFields.ATTRIBUTES]: config?.importantProductAttributeCodes || [],
  [LLMConfigFormFields.KEY_VALUES]: config?.keyValuePropositions || [],
});
